
                  
$('.slider-for1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  infinite: false,
  asNavFor: '.slider-nav1',
  responsive: [
  {
      breakpoint: 991,
      settings: {
        vertical: false,
        arrows: true,
      }
  },
  {
    breakpoint: 768,

    settings: {
      vertical: false,
      arrows: true,
    }
  }
  ]
});

$('.slider-nav1').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  vertical:false,
  asNavFor: '.slider-for1',
  infinite: false,
  dots: false,
  focusOnSelect: true,
  verticalSwiping:true,
  arrows: false,
  responsive: [
  {
      breakpoint: 991,
      settings: {
        vertical: false,

      }
  },
  {
    breakpoint: 768,
    settings: {
      vertical: false,
    }
  },
  {
    breakpoint: 580,
    settings: {
      vertical: false,
      slidesToShow: 4,
    }
  },
  {
    breakpoint: 380,
    settings: {
      vertical: false,
      slidesToShow: 4,
    }
  }
  ]
});



$(".prev-btn").click(function () {
  $(".slider-for1").slick("slickPrev");
});

$(".next-btn").click(function () {
  $(".slider-for1").slick("slickNext");
});
$(".prev-btn").addClass("slick-disabled");
$(".slider-for1").on("afterChange", function () {
  if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn").addClass("slick-disabled");
  } else {
      $(".prev-btn").removeClass("slick-disabled");
  }
  if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn").addClass("slick-disabled");
  } else {
      $(".next-btn").removeClass("slick-disabled");
  }
});

$('.video_container_main').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: false,
  fade: false,
  responsive: [
  {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        vertical: false,
        arrows: true,
        centerMode: true, 
        centerPadding:'180px',
      }
  },
  {
    breakpoint: 768,
      settings: {
        vertical: false,
        dots: true,
        arrows: true,
        slidesToShow: 1,
          vertical: false,
          arrows: true,
          centerMode: false,
          centerPadding:'0px',
      }
    }
  ]
});
$(".prev-btn1").click(function () {
$(".video_container_main").slick("slickPrev");
});

$(".next-btn1").click(function () {
$(".video_container_main").slick("slickNext");
});
$(".prev-btn1").addClass("slick-disabled");
$(".video_container_main").on("afterChange", function () {
  if ($(".slick-prev").hasClass("slick-disabled")) {
      $(".prev-btn1").addClass("slick-disabled");
  } else {
      $(".prev-btn1").removeClass("slick-disabled");
  }
  if ($(".slick-next").hasClass("slick-disabled")) {
      $(".next-btn1").addClass("slick-disabled");
  } else {
      $(".next-btn1").removeClass("slick-disabled");
  }
});

// <!-- qty script -->
$(document).ready(function(){
$(".plus").click(function(){
  var val= $(".number").val();
  val++;
  if(val >= 1){
    $(".number").attr("value", val);
  }
});
$(".minus").click(function(){
  var val= $(".number").val();
  val--;
  if(val >= 1){
    $(".number").attr("value", val);
  }
});
});

// <!-- tab script -->
let list = document.querySelectorAll("ul li");
let content = Array.from(document.querySelectorAll(".content div"));

list.forEach((li) => {
li.addEventListener("click", (e) => {
  // Remove All Active Class
  list.forEach((li) => {
    li.classList.remove("active");
    e.currentTarget.classList.add("active");
  });

  content.forEach((div) => {
    div.classList.remove("active");
    document
      .querySelector(e.currentTarget.dataset.num)
      .classList.add("active");
  });
});
});

// <!-- accordion script -->
const toggleBtns= document.querySelectorAll('.accordion');
toggleBtns.forEach(toggleBtn => {
toggleBtn.addEventListener('click', ()=>{
  toggleBtn.parentNode.classList.toggle('active')
})
});


function updateColor(form) {
const selectedInput = document.querySelector(`.product-form__input .varints_box input[name="${window.queryInput}"]:checked`);
// console.log(selectedInput);
document.querySelectorAll('.slider_box_slider').forEach(
  slider => {
    if(slider.dataset.slider == selectedInput.value){
      slider.dataset.open = 'true';
    }else {
      slider.dataset.open = 'false';
      
    }
  }
)

document.querySelectorAll(`.product-form__input .varints_box input[name="${window.queryInput}"]`).forEach(
  input => {
    if(window[`slider_for_${String(input.value).split(' ').join('-').toLowerCase()}`]){
      window[`slider_for_${String(input.value).split(' ').join('-').toLowerCase()}`].slick('unslick')
    }

    if(window[`slider_nav_${String(input.value).split(' ').join('-').toLowerCase()}`]){
      window[`slider_nav_${String(input.value).split(' ').join('-').toLowerCase()}`].slick('unslick')
    }

    if(input == selectedInput){
      if(window[`slider_for_${String(input.value).split(' ').join('-').toLowerCase()}`]){
        window[`slider_for_${String(input.value).split(' ').join('-').toLowerCase()}`].slick(window[`slider_for_settings_${String(input.value).split(' ').join('-').toLowerCase()}`]);
      }

      if(window[`slider_nav_${String(input.value).split(' ').join('-').toLowerCase()}`]){
        window[`slider_nav_${String(input.value).split(' ').join('-').toLowerCase()}`].slick(window[`slider_nav_settings_${String(input.value).split(' ').join('-').toLowerCase()}`])
      }

      // console.log(window[`slider_nav_settings_${String(input.value).split(' ').join('-').toLowerCase()}`]);
    }
  }
)
}


$(document).ready(function(){
// Add smooth scrolling to all links
$("a").on('click', function(event) {

  // Make sure this.hash has a value before overriding default behavior
  if (this.hash !== "") {
    // Prevent default anchor click behavior
    event.preventDefault();

    // Store hash
    var hash = this.hash;

    // Using jQuery's animate() method to add smooth page scroll
    // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
    $('html, body').animate({
      scrollTop: $(hash).offset().top
    }, 800, function(){

      // Add hash (#) to URL when done scrolling (default click behavior)
      window.location.hash = hash;
    });
  } // End if
});
});
